<template>
  <div class="dashboard-section">
    <v-row class="dashboard-cards">
      <!-- Member Info Card -->
      <v-col cols="12" md="3">
        <v-card class="dashboard-card member-info-card" elevation="4">
          <v-card-text class="text-center pa-4">
            <!-- Member Avatar Section -->
            <div class="member-avatar-section mb-3">
              <v-avatar size="60" class="member-avatar mb-2">
                <img
                  :src="dashboardInfo.ProfilePhoto"
                  :alt="dashboardInfo.MemberName"
                />
              </v-avatar>
            </div>
            <h4 class="card-title">
              {{ dashboardInfo.MemberCardTitle }}
            </h4>
            <div class="member-info">
              <div class="info-item">
                <span class="info-label">Name</span>
                <span class="info-value">{{ dashboardInfo.MemberName }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Membership ID</span>
                <span class="info-value">{{ dashboardInfo.MembershipId }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Mobile Verified</span>
                <v-chip
                  :color="dashboardInfo.MobileVerified ? '#28a745' : '#dc3545'"
                  dark
                  small
                  class="status-chip"
                >
                  <v-icon left size="12" color="white">
                    {{ dashboardInfo.MobileVerified ? "mdi-check-circle" : "mdi-close-circle" }}
                  </v-icon>
                  {{ dashboardInfo.MobileVerified ? "Verified" : "Not Verified" }}
                </v-chip>
              </div>
              <div class="info-item">
                <span class="info-label">Aadhar Verified</span>
                <v-chip
                  :color="dashboardInfo.AadharVerified ? '#28a745' : '#dc3545'"
                  dark
                  small
                  class="status-chip"
                >
                  <v-icon left size="12" color="white">
                    {{ dashboardInfo.AadharVerified ? "mdi-check-circle" : "mdi-close-circle" }}
                  </v-icon>
                  {{ dashboardInfo.AadharVerified ? "Verified" : "Not Verified" }}
                </v-chip>
              </div>
              <div class="info-item">
                <span class="info-label">Profile Status</span>
                <v-chip
                  :color="dashboardInfo.ProfileStatusColor"
                  dark
                  small
                  class="status-chip"
                >
                  {{ dashboardInfo.ProfileStatusTxt }}
                </v-chip>
              </div>
              <div class="info-item">
                <span class="info-label">Continuous Years</span>
                <div class="subscription-info">
                  <span class="subscription-count">{{ dashboardInfo.ContinuousYears }}</span>
                  <span class="subscription-label">Years Paid</span>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- LO Info Card -->
      <v-col cols="12" md="3">
        <v-card class="dashboard-card lo-info-card" elevation="4">
          <v-card-text class="text-center pa-4">
            <v-icon size="40" color="#56BDA3" class="mb-3"
              >mdi-office-building</v-icon
            >
            <h4 class="card-title">
              {{ dashboardInfo.LomCardTitle }}
            </h4>
            <div class="lo-info">
              <div class="info-item">
                <span class="info-label">LO Name</span>
                <span class="info-value">{{ dashboardInfo.LomName }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Zone</span>
                <span class="info-value">{{ dashboardInfo.Zone }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Voting Count</span>
                <div class="voting-info">
                  <span class="voting-count">{{ dashboardInfo.VotingCount }}</span>
                  <span class="voting-label"> Votes</span>
                </div>
              </div>
              <div class="info-item">
                <span class="info-label">Status</span>
                <v-chip
                  color="#0097D7"
                  dark
                  small
                  class="status-chip"
                >
                  {{ dashboardInfo.Status }}
                </v-chip>
              </div>
              <div class="info-item">
                <span class="info-label">City</span>
                <span class="info-value">{{ dashboardInfo.City }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">District</span>
                <span class="info-value">{{ dashboardInfo.District }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">State</span>
                <span class="info-value">{{ dashboardInfo.State }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Deadline Card -->
      <v-col cols="12" md="3">
        <v-card class="dashboard-card deadline-card" elevation="4">
          <v-card-text class="text-center pa-4">
            <v-icon size="40" color="#0097D7" class="mb-3"
              >mdi-calendar-clock</v-icon
            >
            <h4 class="card-title">Zone Nomination Deadline</h4>

            <div class="deadline-info">
              <div class="date-item">
                <span class="date-label">Start Date</span>
                <span class="date-number">{{
                  dashboardInfo.NominationStartDateTxt
                }}</span>
              </div>
              <div class="date-item">
                <span class="date-label">End Date</span>
                <span class="date-number">{{
                  dashboardInfo.NominationEndDateTxt
                }}</span>
              </div>
            </div>

            <h4 class="card-title">National Nomination Deadline</h4>

            <div class="deadline-info">
              <div class="date-item">
                <span class="date-label">Start Date</span>
                <span class="date-number">{{
                  dashboardInfo.NationalNominationStartDateTxt
                }}</span>
              </div>
              <div class="date-item">
                <span class="date-label">End Date</span>
                <span class="date-number">{{
                  dashboardInfo.NationalNominationEndDateTxt
                }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Statistics Card -->
      <v-col cols="12" md="3">
        <v-card class="dashboard-card statistics-card" elevation="4">
          <v-card-text class="text-center pa-4">
            <v-icon size="40" color="#EDBE38" class="mb-3"
              >mdi-chart-bar</v-icon
            >
            <h4 class="card-title">
              {{ dashboardInfo.StatisticsCardTitle }}
            </h4>
            <div class="stats-info">
              <div class="stat-item">
                <span class="stat-number">{{ dashboardInfo.Total }}</span>
                <span class="stat-label">Total</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">{{ dashboardInfo.Submitted }}</span>
                <span class="stat-label">Submitted</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">{{ dashboardInfo.Pending }}</span>
                <span class="stat-label">Pending</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "NominationDashboardCards",
  props: {
    // Single object containing all dashboard data
    dashboardInfo: {
      type: Object,
    },
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
// Dashboard Cards Section
.dashboard-section {
  margin: 2rem 0;

  .dashboard-cards {
    margin: 0 -12px;

    .dashboard-card {
      cursor: pointer;
      transition: all 0.3s ease;
      border-radius: 12px !important;
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
      height: 100%;
      display: flex;
      flex-direction: column;

      .v-card__text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
      }

      .card-title {
        color: #2c3e50;
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 1rem;
        font-family: "Roboto", sans-serif;
      }

      &.member-info-card {
        border-left: 4px solid #3a67b1;

        .member-avatar-section {
          .member-avatar {
            border: 3px solid #3a67b1 !important;
            box-shadow: 0 4px 12px rgba(58, 103, 177, 0.3) !important;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .member-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 16px;
            background: rgba(58, 103, 177, 0.1);
            border-radius: 8px;
            border: 1px solid rgba(58, 103, 177, 0.2);
            transition: all 0.2s ease;

            &:hover {
              background: rgba(58, 103, 177, 0.15);
              transform: translateX(2px);
            }

            .info-label {
              color: #3a67b1;
              font-weight: 600;
              font-size: 0.85rem;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              white-space: nowrap;
            }

            .info-value {
              color: #2c3e50;
              font-weight: 600;
              font-size: 0.9rem;
              text-align: right;
              word-break: break-word;
            }

            .status-chip {
              font-weight: 600 !important;
              font-size: 0.75rem !important;
              height: 24px !important;

              .v-icon {
                margin-right: 2px !important;
              }
            }

            .subscription-info {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              text-align: right;

              .subscription-count {
                color: #3a67b1;
                font-weight: 700;
                font-size: 1.1rem;
                line-height: 1;
              }

              .subscription-label {
                color: #666;
                font-weight: 500;
                font-size: 0.75rem;
                text-transform: uppercase;
                letter-spacing: 0.3px;
              }
            }

            .voting-info {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              text-align: right;

              .voting-count {
                color: #56bda3;
                font-weight: 700;
                font-size: 1.1rem;
                line-height: 1;
              }

              .voting-label {
                color: #666;
                font-weight: 500;
                font-size: 0.75rem;
                text-transform: uppercase;
                letter-spacing: 0.3px;
              }
            }
          }
        }
      }

      &.lo-info-card {
        border-left: 4px solid #56bda3;

        .lo-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 16px;
            background: rgba(86, 189, 163, 0.1);
            border-radius: 8px;
            border: 1px solid rgba(86, 189, 163, 0.2);
            transition: all 0.2s ease;

            &:hover {
              background: rgba(86, 189, 163, 0.15);
              transform: translateX(2px);
            }

            .info-label {
              color: #56bda3;
              font-weight: 600;
              font-size: 0.9rem;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }

            .info-value {
              color: #2c3e50;
              font-weight: 600;
              font-size: 0.9rem;
            }

            .status-chip {
              font-weight: 600 !important;
              font-size: 0.8rem !important;
            }
          }
        }
      }

      &.deadline-card {
        border-left: 4px solid #0097d7;

        .deadline-info {
          display: flex;
          flex-direction: column;
          gap: 12px;
          flex: 1;

          .date-item {
            text-align: center;
            padding: 16px 12px;
            background: rgba(0, 151, 215, 0.1);
            border-radius: 8px;
            border: 1px solid rgba(0, 151, 215, 0.2);
            transition: all 0.2s ease;

            &:hover {
              background: rgba(0, 151, 215, 0.15);
              transform: translateY(-1px);
            }

            .date-number {
              display: block;
              font-size: 0.85rem;
              font-weight: 600;
              color: #0097d7;
              line-height: 1.2;
              margin-bottom: 4px;
              word-break: break-all;
              white-space: normal;
            }

            .date-label {
              display: block;
              font-size: 0.85rem;
              color: #666;
              font-weight: 500;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
          }

          .time-remaining {
            text-align: center;

            .time-chip {
              font-weight: 600 !important;
              font-size: 0.8rem !important;
            }
          }
        }
      }

      &.statistics-card {
        border-left: 4px solid #edbe38;

        .stats-info {
          display: flex;
          flex-direction: column;
          gap: 12px;
          flex: 1;

          .stat-item {
            text-align: center;
            padding: 16px 12px;
            background: rgba(237, 190, 56, 0.1);
            border-radius: 8px;
            border: 1px solid rgba(237, 190, 56, 0.2);
            transition: all 0.2s ease;

            &:hover {
              background: rgba(237, 190, 56, 0.15);
              transform: translateY(-1px);
            }

            .stat-number {
              display: block;
              font-size: 1.8rem;
              font-weight: 700;
              color: #edbe38;
              line-height: 1;
              margin-bottom: 4px;
            }

            .stat-label {
              display: block;
              font-size: 0.85rem;
              color: #666;
              font-weight: 500;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
          }
        }
      }
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  .dashboard-section {
    margin: 1.5rem 0;

    .dashboard-cards {
      margin: 0 -8px;

      .dashboard-card {
        margin-bottom: 1rem;

        .card-title {
          font-size: 0.95rem;
        }

        &.member-info-card {
          .member-info {
            .info-item {
              padding: 10px 14px;

              .info-label {
                font-size: 0.8rem;
              }

              .info-value {
                font-size: 0.85rem;
              }

              .subscription-info {
                .subscription-count {
                  font-size: 1rem;
                }
              }
            }
          }
        }

        &.statistics-card {
          .stats-info {
            .stat-item {
              padding: 12px 8px;

              .stat-number {
                font-size: 1.5rem;
              }

              .stat-label {
                font-size: 0.8rem;
              }
            }
          }
        }

        &.deadline-card {
          .deadline-info {
            .date-item {
              padding: 12px 8px;

              .date-number {
                font-size: 0.8rem;
              }

              .date-label {
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .dashboard-section {
    .dashboard-cards {
      .dashboard-card {
        &.member-info-card {
          .member-avatar-section {
            .member-avatar {
              width: 50px !important;
              height: 50px !important;
            }
          }

          .member-info {
            .info-item {
              flex-direction: column;
              align-items: flex-start;
              text-align: left;

              .info-label {
                margin-bottom: 4px;
              }

              .subscription-info {
                align-items: flex-start;
                text-align: left;
              }
            }
          }
        }

        &.lo-info-card {
          .info-item {
            flex-direction: column;
            align-items: flex-start;

            .info-label {
              margin-bottom: 4px;
            }
          }
        }

        &.deadline-card {
          .deadline-info {
            .date-item {
              padding: 12px 8px;

              .date-number {
                font-size: 0.75rem;
                margin-bottom: 6px;
              }

              .date-label {
                font-size: 0.75rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
